export const strings = {
  webinars: 'Web seminerleri',
  events: 'Olaylar',
  groups: 'Gruplar',
  people: 'İnsanlar',
  microsites: 'Mikrositeler',
  articles: 'Makaleler',
  cases: 'Davalar',
  jobs: 'İşler',
  all: 'Tüm',
  no_results: 'Hiçbir sonuç bulunamadı',
  no_result_message: 'Herhangi bir sonuç bulamadık',
  news: 'Haberler',
  conference_proceeding: 'Konferans Bildirileri',
  search_by_name: 'İsme göre ara',
};